module.exports = __webpack_public_path__ + "img/DiferenciaHorariaCCTV.838a16a8.svg";